/**
 * BookingSlotIndicator — semaforo umano.
 */
import React from "react";
import { humanSlotMessage } from "@/lib/reservations";

const TONE = {
  green:  "bg-emerald-50 border-emerald-300 text-emerald-900",
  yellow: "bg-amber-50 border-amber-300 text-amber-900",
  red:    "bg-rose-50 border-rose-300 text-rose-900",
};
const DOT = { green: "bg-emerald-500", yellow: "bg-amber-500", red: "bg-rose-600" };

export default function BookingSlotIndicator({ load, onPickSuggestion }) {
  if (!load) return null;
  const msg = humanSlotMessage(load);
  if (!msg) return null;
  return (
    <div className={`rounded-xl border p-3 space-y-1 ${TONE[msg.tone]}`}
         data-testid="booking-slot-indicator"
         data-status={load.status}>
      <div className="flex items-center gap-2">
        <span className={`w-2.5 h-2.5 rounded-full ${DOT[msg.tone]}`} />
        <div className="font-medium text-sm">{msg.title}</div>
      </div>
      <div className="text-sm">{msg.body}</div>
      {msg.suggested?.length > 0 && (
        <div className="flex flex-wrap gap-2 pt-1" data-testid="booking-slot-suggestions">
          <span className="text-xs opacity-70 self-center">Ti consigliamo:</span>
          {msg.suggested.map((t) => (
            <button key={t} type="button"
                    onClick={() => onPickSuggestion && onPickSuggestion(t)}
                    data-testid={`booking-slot-sugg-${t}`}
                    className="px-3 h-8 rounded-full bg-white border border-current text-sm tabular-nums active:opacity-70">
              {t}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
